import { createActions, createConsts, createReducer } from '../../utils/redux';

export const consts = createConsts(
  'communities',
  'postsCreated',
  'UPDATE',
  'CLEAR',
);
export const actions = createActions(consts);

export default createReducer(0, {
  [consts.UPDATE]: (state, action) => {
    const newState = state + action.payload;

    return Math.max(newState, 0);
  },

  [consts.CLEAR]: (state, action) => 0,
});



// WEBPACK FOOTER //
// ./src/redux/communities/postsCreated.js